import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import SaveButton from "../../../components/Buttons/SaveButton";
import DateControl from "../../../components/Fields/DateControl";
import TextboxControl from "../../../components/Fields/TextboxControl";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import Translate from "../../../components/Translate";
import { useNotifications } from "../../../contexts/notificationContext";
import BusinessPartnerModel from "../../../models/BusinessPartnerModel";
import BusinessPartnerReferenceModel from "../../../models/BusinessPartnerReferenceModel";
import DataService from "../../../services/data.service";
import { Result } from "../../../types/Result";

interface BusinessPartnerReferencesUpdateModel {
    businessPartnerId: number
    businessPartnerReferences: BusinessPartnerReferenceModel[]
}

interface Props {
    show: boolean
    onHide: () => void
    businessPartner: BusinessPartnerModel
}

const EditBusinessPartnerReferencesPopup: React.FC<Props> = ({ show, onHide, businessPartner }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<BusinessPartnerReferencesUpdateModel>();

    useEffect(() => {
        DataService.get<BusinessPartnerReferenceModel[]>('api/v1/BusinessPartnerReferences/ByBusinessPartner/' + businessPartner.id)
            .then(response => {
                setFormData({
                    businessPartnerId: businessPartner.id,
                    businessPartnerReferences: response
                })
            })
    }, [businessPartner]);

    function submit() {
        if (formData) {
            DataService
                .update(`api/v1/BusinessPartnerReferences`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [],
        handleSubmit: submit,
        showErrors: 'always',
    };

    if (formData?.businessPartnerReferences) {
        formData.businessPartnerReferences.forEach((businessPartnerReference, index) => {
            formConfig.fields.push({ name: `businessPartnerReferences.${index}.referenceCode`, label: businessPartnerReference.externalSystemName, validationRules: [{ type: 'isMaxLength', maxLength: 50 }] });
            formConfig.fields.push({ name: `businessPartnerReferences.${index}.readyForExportOn`, label: 'Ready for export on' });
            formConfig.fields.push({ name: `businessPartnerReferences.${index}.exportedOn`, label: 'Exported on' });
        })
    }

    const { getControlProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Edit external references'} >
            <Popup.Body>
                {formData?.businessPartnerReferences && formData.businessPartnerReferences.length > 0 && (
                    <>
                        <table>
                            <tr>
                                <th className='col-md-2'></th>
                                <th className='col-md-6'><Translate>Reference code</Translate></th>
                                <th className='col-md-2'><Translate>Ready for export</Translate></th>
                                <th className='col-md-2'><Translate>Exported</Translate></th>
                            </tr>
                            {formData.businessPartnerReferences.map((businessPartnerReference, index) => {
                                return (
                                    <tr>
                                        <td><Form.Label>{businessPartnerReference.externalSystemName}</Form.Label></td>
                                        <td><TextboxControl {...getControlProps(`businessPartnerReferences.${index}.referenceCode`)} key={index} /></td>
                                        <td><DateControl {...getControlProps(`businessPartnerReferences.${index}.readyForExportOn`)} disabled key={index} /></td>
                                        <td><DateControl {...getControlProps(`businessPartnerReferences.${index}.exportedOn`)} disabled key={index} /></td>
                                    </tr>
                                )
                            })
                            }
                        </table>
                    </>
                )}
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default EditBusinessPartnerReferencesPopup;